export default {"src":"/_next/static/media/double-arrow-right_svgrepo.com.e0697e20.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};